import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import CloseIcon from "../../icons/CloseIcon";
import RequestBuyMobile from "../common/mobile/RequestBuyMobile";
import HomeIcon from "../../icons/HomeIcon";
import CategoryIcon from "../../icons/CategoryIcon";
import WalletIcon from "../../icons/WalletIcon";
import { httpReauest } from "../../utils/httpRequest";
import TimerIcon from "../../icons/TimerIcon";
import Countdown from "react-countdown";
import ChatIcon from "../../icons/ChatIcon";
import ChatIcon2 from "../../icons/ChatIcon2";
import Chat from "./Chat";
import { PiChatsCircleDuotone } from "react-icons/pi";
const LayoutMobile = ({ footer }) => {
  const [show, setShow] = useState();
  const [data, setData] = useState();
  const [show2, setShow2] = useState();
  const [buyRequest, setbuyRequest] = useState();
  const [loading, setloading] = useState();
  const { pathname } = useLocation();

  const [hour, sethours] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  function handleShow(params) {
    setShow2(true);

    setTimeout(() => {
      setShow2(false);
    }, 3000);
  }

  async function getData() {
    setloading(true);
    await httpReauest("GET", "/vehicle/timer", {}, {}).then(({ data }) => {
      sethours(new Date() < new Date(data?.data?.hour));
    });
    await httpReauest("GET", `/data`, {}, {}).then(({ data }) => {
      setData(data?.data[0]);
    });
    setloading(false);
  }

  const renderer = ({ hours, minutes, seconds, completed, days }) => {
    if (completed) {
      return (
        <span className="flex flex-col items-center">
          <TimerIcon color />
          {hours}:{minutes}:{seconds}
        </span>
      );
    }
    return (
      <span className="flex flex-col items-center">
        <TimerIcon color />
        {hours}:{minutes}:{seconds}
      </span>
    );
  };
  return (
    <>
      {buyRequest && <RequestBuyMobile setbuyRequest={setbuyRequest} />}

      {show && (
        <div
          onClick={() => setShow(false)}
          className="fixed top-0 left-0 h-full w-full bg-[#000000d2] z-40"
        ></div>
      )}
      <div
        className={`h-full z-40 top-0 w-[75%] bg-white p-4  fixed duration-200 ${
          show ? "right-0" : "-right-full"
        }`}
      >
        <div className="flex justify-center relative border-b py-5">
          <span className="flex flex-col items-center justify-center">
            <img src="/logo_1924.svg" alt="لوگوی 1924" className="w-[90px]" />
            <span className="text-[8px] font-medium">
              مرکز خرید و فروش ماشین های سنگین
            </span>
          </span>

          <span
            onClick={() => setShow(false)}
            className="absolute right-0 top-[50%] translate-y-[-50%]"
          >
            <CloseIcon />
          </span>
        </div>
        <div className="flex flex-col gap-5 py-6 text-[16px] px-4">
          <span className="relative">
            <Link
              onClick={() => setShow(false)}
              className="yellow-circle-small"
              to={"/category"}
            >
              دسته بندی
            </Link>
          </span>
          <span className="relative">
            <Link
              onClick={() => setShow(false)}
              className="yellow-circle-small"
              to={"/targeted-buy"}
            >
              خرید هدفمند
            </Link>
          </span>
          <span className="relative">
            <Link
              onClick={() => setShow(false)}
              className="yellow-circle-small"
              to={"/contact"}
            >
              تماس با ما
            </Link>
          </span>
          <span className="relative">
            <Link
              onClick={() => setShow(false)}
              className="yellow-circle-small"
              to={"/work-with-us"}
            >
              همکاری با ما
            </Link>
          </span>
          <span className="relative">
            <Link
              onClick={() => setShow(false)}
              className="yellow-circle-small"
              to={"/about"}
            >
              درباره ما
            </Link>
          </span>
          <span className="relative">
            <Link
              onClick={() => setShow(false)}
              className="yellow-circle-small"
              to={"/blogs"}
            >
              اخبار و دانستنی ها
            </Link>
          </span>
          <span className="relative">
            <Link
              onClick={() => setShow(false)}
              className="yellow-circle-small"
              to={"/compare"}
            >
              مقایسه خودرو ها
            </Link>
          </span>
          <span className="relative">
            <Link
              onClick={() => setShow(false)}
              className="yellow-circle-small"
              to={"/brands"}
            >
              برند ها
            </Link>
          </span>
        </div>
      </div>
      <div className="fixed top-0 bg-white flex justify-between items-center w-full left-0 px-5 py-4 z-30">
        <img
          onClick={() => setShow(true)}
          src="/menu.png"
          className="w-[24px]"
          alt=""
        />

        <Link className="flex flex-col items-center justify-center" to={"/"}>
          <img src="/logo_1924.svg" alt="لوگوی 1924" className="w-[90px]" />
          <span className="text-[8px] font-medium">
              مرکز خرید و فروش ماشین های سنگین
            </span>
        </Link>
        <Link to={"/chat"}>
          <PiChatsCircleDuotone
            size={25}
            className="chat_icon"
            color="#FFA800"
          />
        </Link>
      </div>
      {!footer && (
        <div
          style={{
            backgroundImage: "url(/Exclude.png)",
          }}
          className="fixed bottom-0 left-0 w-full p-2 grid grid-cols-5 text-[12px] sm::text-[14px] bg-center md:bg-cover z-30"
        >
          <Link to={"/"} className="flex flex-col justify-center items-center">
            {pathname == "/" ? <HomeIcon fill /> : <HomeIcon />}
            <p>خانه</p>
          </Link>
          {hour ? (
            <Link
              to={"/discounted"}
              className="flex flex-col justify-center items-center"
            >
              <TimerIcon color />
              <p>زیر قیمت</p>
            </Link>
          ) : (
            <button
              onClick={handleShow}
              className="flex flex-col justify-center items-center relative "
            >
              <span
                className={`${
                  show2 ? "opacity-100" : "opacity-0"
                } absolute left-0 bottom-full bg-red-500 w-full p-1 rounded-[5px] text-white text-[8px] duration-200`}
              >
                زیر قیمتی در حال حاضر نداریم
              </span>
              <TimerIcon color />
              <p>زیر قیمت</p>
            </button>
          )}
          {loading ? (
            <span>
              <span className="icon_phone">
                <img src="/1/Call.png " className="w-[24px]" alt="" />
              </span>
            </span>
          ) : (
            <Link to={`tel:${data?.phone}`}>
              <span className="icon_phone">
                <img src="/1/Call.png " className="w-[24px]" alt="" />
              </span>
            </Link>
          )}

          <span
            onClick={() => setbuyRequest(true)}
            className="flex flex-col justify-center items-center"
          >
            <img src="/tabler_bell-dollar.png" className="w-[24px]" alt="" />
            <p>خرید و فروش</p>
          </span>
          <Link
            to={"/pay-later"}
            className="flex flex-col justify-center items-center"
          >
            {pathname == "/pay-later" ? <WalletIcon /> : <WalletIcon />}
            <p>اقساط</p>
          </Link>
        </div>
      )}
    </>
  );
};

export default LayoutMobile;
